export default __webpack_public_path__ + "static/media/wasp_p_header.cfb506d2.svg";